module.exports = __webpack_public_path__ + "img/cost_plus_world_market.8063b150.png";